import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import Chip from '@mui/material/Chip'
import TextField from '@mui/material/TextField'
import styled from 'styled-components'

export const DashboardContainer = styled.div`
  padding: 32px;
  background: #f4f4f4;
  min-height: calc(100vh - 64px);
  overflow-y: auto;
  height: calc(100vh - 64px);
`

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 32px;
`

export const Title = styled(Typography)`
  font-weight: 600;
  color: ${({ theme }) => theme.black?.main || '#111111'};
`

export const LoadingContainer = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 400px;
  gap: 16px;
`

export const MetricCard = styled(Paper)`
  padding: 24px;
  background: white;
  border-radius: 16px;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.primary?.main || '#EEEDED'};
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  &:hover {
    transform: translateY(-4px);
    border-color: ${({ theme }) => theme.link?.main || '#0074FE'};

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: ${props => {
      const colorMap = {
        link: props.theme?.link?.main || '#0074FE',
        success: props.theme?.successDark?.main || '#05AD48',
        error: props.theme?.error?.main || '#FC7777',
        warning: props.theme?.warning?.main || '#f08249',
      }
      return colorMap[props.$color] || '#0074FE'
    }};
  }
`

export const MetricHeader = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
`

export const MetricIcon = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #f4f4f4;
  color: ${props => {
    const colorMap = {
      link: props.theme?.link?.main || '#0074FE',
      success: props.theme?.successDark?.main || '#05AD48',
      error: props.theme?.error?.main || '#FC7777',
      warning: props.theme?.warning?.main || '#f08249',
    }
    return colorMap[props.$color] || '#0074FE'
  }};
`

export const MetricLabel = styled(Typography)`
  font-size: 14px;
  font-weight: 500;
  color: ${({ theme }) => theme.fieldLabel?.main || '#7D7D7D'};
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const MetricContent = styled.div`
  flex: 1;
`

export const MetricValue = styled(Typography)`
  font-size: 36px;
  font-weight: 700;
  color: ${({ theme }) => theme.black?.main || '#111111'};
  line-height: 1;
`

export const MetricFooter = styled.div`
  margin-top: auto;
  padding-top: 12px;
`

export const MetricChange = styled(Typography)`
  font-size: 14px;
  color: ${props =>
    props.$positive
      ? props.theme?.successDark?.main || '#05AD48'
      : props.theme?.error?.main || '#FC7777'};
  display: flex;
  align-items: center;
  gap: 4px;
`

export const DateRangeContainer = styled(Box)`
  display: flex;
  gap: 16px;
  margin-bottom: 32px;
  padding: 24px;
  background: white;
  border-radius: 16px;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.primary?.main || '#EEEDED'};
`

export const StyledTextField = styled(TextField)`
  .MuiOutlinedInput-root {
    border-radius: 12px;

    &:hover fieldset {
      border-color: ${({ theme }) => theme.link?.main || '#0074FE'};
    }

    &.Mui-focused fieldset {
      border-color: ${({ theme }) => theme.link?.main || '#0074FE'};
    }
  }
`

export const DataTable = styled(Paper)`
  background: white;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: none;
  border: 1px solid ${({ theme }) => theme.primary?.main || '#EEEDED'};
`

export const TableHeader = styled.div`
  padding: 20px 24px;
  background: ${({ theme }) => theme.link?.main || '#0074FE'};
  color: white;
  display: flex;
  justify-content: space-between;
  align-items: center;
`

export const TableHeaderActions = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
`

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
`

export const TableHead = styled.thead`
  background: #f9fafb;
  border-bottom: 2px solid ${({ theme }) => theme.primary?.main || '#EEEDED'};
`

export const TableRow = styled.tr`
  &:hover {
    background: #f9fafb;
  }

  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.primary?.main || '#EEEDED'};
  }
`

export const TableHeaderCell = styled.th`
  padding: 12px 24px;
  text-align: left;
  font-weight: 600;
  color: ${({ theme }) => theme.fieldLabel?.main || '#7D7D7D'};
  font-size: 12px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
`

export const TableCell = styled.td`
  padding: 16px 24px;
  color: ${({ theme }) => theme.black?.main || '#111111'};
  font-size: 14px;
`

export const Badge = styled(Chip)`
  font-weight: 600;
  font-size: 14px !important;
`

export const EmptyState = styled.div`
  padding: 48px;
  text-align: center;
  color: ${({ theme }) => theme.fieldLabel?.main || '#7D7D7D'};
`
